module.exports = __webpack_public_path__ + "assets/9aae0f5e262dadb7868abe0dc139edaf.png";